module.exports = __webpack_public_path__ + "img/inter-v3-latin-ext_latin-regular.4593a4c.svg";